export default __webpack_public_path__ + "menu-store-smop-icon.cdb8d790e6dee64e02250664b3a14055.svg";